export enum ImportType {
  CLIMKIT = "climkit",
  SIL = "email-SIL",
  // HELLO = "hello",
  METEOSUISSE = "meteosuisse",
  TETRAEDRE = "tetraedre",
}

export function importTypeFromString(importType: string): ImportType {
  switch (importType) {
    case "CLIMKIT":
      return ImportType.CLIMKIT;
    case "SIL":
      return ImportType.SIL;
    // case "HELLO":
    //   return ImportType.HELLO;
    case "METEOSUISSE":
      return ImportType.METEOSUISSE;
    case "TETRAEDRE":
      return ImportType.TETRAEDRE;
    default:
      throw new Error(`Unknown import type ${importType}`);
  }
}
